import Typography from "Clutch/Atoms/Typography";
import styles from "./common.module.scss"

const ContextualError = ({ error }) => {
    if (!error || !error.message.length) {
        return <div className={styles.errorPlaceholder} />;
    }
    return <Typography data-testid={`${error.id}_error`} size={0.75} intent={'negative'}>{error.message}</Typography>;
}

export default ContextualError;